import {HyperDropComponent} from "./HyperDropComponent";

export class HyperDropPanel extends HyperDropComponent {

  isOpen: boolean = false
  backdrop: HTMLElement;
  closeBtn: HTMLElement;
  panel: HTMLElement;

  onMount(): void {
    this.elements.backdrop.addEventListener('click', () => this.close());
    this.elements.closeBtn.addEventListener('click',() => this.close());
    if(this.elements.toggle) {
      this.elements.toggle.addEventListener('click', () => {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      });
    }
  }

  listenForEscape(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  open() {
    this.elements.panel.classList.add('open');
    this.elements.backdrop.classList.add('visible')
    this.isOpen = true;
    document.addEventListener('keydown', (e) => this.listenForEscape(e));
  }

  close() {
    this.elements.panel.classList.remove('open');
    this.elements.backdrop.classList.remove('visible')
    this.isOpen = false;
    document.removeEventListener('keydown', (e) => this.listenForEscape(e));
  }
}
